
import { defineComponent, ref, reactive, watch, nextTick, onMounted, onBeforeUnmount, getCurrentInstance } from 'vue'
import { mapState, useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'

import COVERAPP from '@/utils/COVERAPP'

export default defineComponent({
    computed: {
        ...mapState(['activityData'])
    },
    props: ['data'],
    setup (props, context) {
        const $store = useStore()
        const _this = getCurrentInstance() as any
        const $route = useRoute()
        const $router = useRouter()
        const COVER = _this.proxy.$common
        let canvas: any = null
        let ctx: any = null
        let width = 0
        let height = 0
        const particles: any = []

        // 粒子类
        class Particle {
            public options: any
            public radius: number
            public x: number
            public y: number
            public color: string
            public vx: number = 0
            public vy: number = 0

            constructor(options) {
                const {x, y, radius, color} = options
                this.options = options
                this.x = x
                this.y = y
                this.radius = radius
                this.color = color
                this.vx = (Math.random() - 0.5) * 0.1
                this.vy = (Math.random() - 0.5) * 0.1
            }
            
            update() {
                this.x += Math.random() - 0.5
                this.y += Math.random() - 0.5
            }
            
            draw() {
                ctx.beginPath()
                ctx.arc(this.x, this.y, this.radius, 0, 2 * Math.PI, false);
                ctx.fillStyle = this.color
                ctx.fill()
            }
        }

        const initParticles = ({count, size, radius, color, space}) => {
            const angleStep = 2 * Math.PI / count
            let angle = 0
            for (let i = 0; i < count; i++) {
                const x = width / 2 + size * Math.cos(angle) + (Math.random() - 0.5) * space
                const y = height / 2 + size * Math.sin(angle) + (Math.random() - 0.5) * space
                particles.push(new Particle({
                    x, 
                    y, 
                    radius, 
                    color: Math.random() < 0.04 ? color[1] : color[0]
                }))
                angle += angleStep
            }
        }

        const initCircular = () => {
            for (let i = 1; i < 5; i++) {
                initParticles({
                    count: 120 - i * 20,
                    size: (width - i * 100 + 50) / 2,
                    radius: 7,
                    color: ['#fe9300', '#ffd100'],
                    space: i === 4 ? 350 : (i + 1) * 20
                })
            }
        }

        const draw = () => {
            ctx.clearRect(0, 0, width, height)
            particles.forEach((particle: any) => {
                particle.update()
                particle.draw()
            })
        }

        let animateId = 0
        const animate = () => {
            draw()
            cancelAnimationFrame(animateId)
            animateId = requestAnimationFrame(animate)
        }
        
        onBeforeUnmount(() => {
            ctx.clearRect(0, 0, width, height)
            cancelAnimationFrame(animateId)
        })

        onMounted(() => {
            canvas = document.querySelector('.circular-container canvas')
            canvas.width = 800
            canvas.height = 800
            ctx = canvas.getContext('2d')
            width = canvas.width
            height = canvas.height
            initCircular()
            animate()
        })    

        return {
            
        }
    }
})
